import Notice, { NoticeProps } from '@codegouvfr/react-dsfr/Notice';
import React from 'react';
import { ToastContentProps } from 'react-toastify';
import './fcToast.css';
import Severity = NoticeProps.Severity;

export const FcToast = ({ closeToast, data }: ToastContentProps) => {
  const { message, description, type }: FcToastData = data;

  return (
    <Notice description={description ?? ''}
            iconDisplayed
            isClosable
            onClose={() => closeToast()}
            severity={type ?? 'info'}
            title={message} />
  );
};

export interface FcToastData {
  message: string;
  description?: string;
  type?: Severity;
}